/* Пометка источника: видно, но не кричит — это оговорка, а не тревога. */

.fixture-notice {
  display: flex;
  gap: var(--sp-2);
  align-items: flex-start;
  margin-bottom: var(--sp-4);
  padding: var(--sp-2) var(--sp-3);
  border: 1px dashed var(--data-candidate-line);
  border-radius: var(--radius-control);
  background: var(--data-candidate-soft);
  color: var(--brown-ink);
  font-size: var(--type-caption-size);
  line-height: var(--type-caption-line);
}

.fixture-notice svg {
  flex: none;
  margin-top: 1px;
}

.fixture-notice strong {
  font-weight: var(--fw-semibold);
}
